import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import html2canvas from 'html2canvas';
export default {
  data: function data() {
    return {
      base64Str: '',
      generated: false,
      processing: false,
      maskStyle: {
        height: '100%',
        width: '100%'
      },
      clientRect: null,
      params: {
        type: 'image/png',
        encoderOptions: 1,
        autoReplace: true,
        // 默认自动将生成的图片替换掉原来的DOM节点
        maskColor: '#eddeb3',
        // 生成图片时遮罩的颜色
        useCORS: true,
        // ---以下复用html2canvas参数
        scale: 2,
        backgroundColor: null,
        logging: true
      }
    };
  },
  methods: {
    generate: function () {
      var _generate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params,
            canvas,
            ctx,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                this.params = _objectSpread(_objectSpread({}, this.params), params); // 生成图片

                _context.prev = 2;
                this.clientRect = this.$el.getBoundingClientRect();
                this.$el.style.width = Math.round(this.clientRect.width) + 'px';
                this.$el.style.height = Math.round(this.clientRect.height) + 'px';
                this.processing = true;
                _context.next = 9;
                return html2canvas(this.$el, this.params);

              case 9:
                canvas = _context.sent;

                if (params.disableSmoothing) {
                  ctx = canvas.getContext('2d');
                  ctx.mozImageSmoothingEnabled = false;
                  ctx.webkitImageSmoothingEnabled = false;
                  ctx.msImageSmoothingEnabled = false;
                  ctx.imageSmoothingEnabled = false;
                }

                this.base64Str = canvas.toDataURL(this.params.type, this.params.encoderOptions);
                this.generated = true;
                this.processing = false;
                this.$emit('success', this.base64Str);
                return _context.abrupt("return", this.base64Str);

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](2);
                this.$emit('fail', _context.t0);
                return _context.abrupt("return", '');

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 18]]);
      }));

      function generate() {
        return _generate.apply(this, arguments);
      }

      return generate;
    }()
  },
  install: function install(Vue) {},
  watch: {
    clientRect: function clientRect(newVal) {
      if (newVal) {
        this.maskStyle.height = newVal.height + 'px';
        this.maskStyle.width = newVal.width + 'px';

        if (this.params.maskColor) {
          this.maskStyle.backgroundColor = this.params.maskColor;
        }
      }
    }
  }
};